import { ALPHA_2_ISO_3166 } from 'cpool-constants';

export const GERMAN_POSTAL_CODE_REGEX = /^\d{5}$/;

// empty is valid, the field is optional; only Germany (or unset country) has a checked format
export const isValidPostalCode = (plz: string | null | undefined, land: string | null | undefined) =>
    plz == null || plz === '' || (land != null && land !== ALPHA_2_ISO_3166.DE) || GERMAN_POSTAL_CODE_REGEX.test(plz);
